export default {
  async fetchCategoryMenuData({ commit, state }) {
    try {
      if (state.categoryMenuData.length) return;
      const { categories } = await this.$axios.$get(
        `${this.$config.baseOfixApi}/e-commerce/v1/categories/tree`,
        {
          params: {
            level: 0,
            nestingLevel: 2,
            includeRecommendedBrands: true,
            includeRecommendedItem: true,
            orderBy: 'popularity',
          },
        },
      );
      commit('setCategoryMenuData', categories);
    } catch {}
  },

  async fetchMobileCategoryMenuData({ commit, state }) {
    try {
      if (state.mobileCategoryMenuData.length) return;
      const { categories } = await this.$axios.$get(
        `${this.$config.baseOfixApi}/e-commerce/v1/categories/tree`,
        {
          params: {
            level: 0,
            nestingLevel: 5,
            includeRecommendedBrands: true,
            includeRecommendedItem: true,
            orderBy: 'popularity',
          },
        },
      );
      commit('setMobileCategoryMenuData', categories);
    } catch {}
  },

  async fetchAutocompleteCategoryMenuData({ commit, state }) {
    try {
      if (state.autocompleteCategoryMenuData) return;
      const { data } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/categories`,
        {
          params: {
            nestingLevel: 0,
            includeRecommendedBrands: false,
            includeRecommendedItem: false,
            orderBy: 'popularity',
          },
        },
      );
      commit('setAutocompleteCategoryMenuData', data);
    } catch {}
  },

  async fetchUserMenuData({ commit, rootGetters }) {
    try {
      const { menuItems } = await this.$axios.$get(
        `${this.$config.baseUrl}/tmpData/${this.$i18n.locale}/menuUser.json`,
      );

      const userPermissions = rootGetters['auth/getPermissions']; // Example: { catalogSubsets: true }

      const filteredMenuItems = menuItems.filter(item => {
        if (!item.permissions) return true; // No permissions required, include the item

        return item.permissions.some(permission => userPermissions[permission]);
      });

      commit('setUserMenuData', { data: filteredMenuItems });
    } catch (error) {}
  },

  async resetState({ dispatch, commit }) {
    await commit('setAutocompleteCategoryMenuData', null);
    await commit('setMobileCategoryMenuData', []);
    await dispatch('fetchMobileCategoryMenuData');
    await dispatch('fetchAutocompleteCategoryMenuData');
    await dispatch('fetchUserMenuData');
  },
};
